import React, { useEffect, useState } from "react";
import AdminLayout from "../components/admin/AdminLayout";
import StatCard from "../components/admin/StatCard";
import RecentOrders from "../components/admin/RecentOrders";

function Dashboard() {
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const [caterCount, setCaterCount] = useState(0);

  useEffect(() => {
    const fetchCaters = async () => {
      try {
        const response = await fetch("/backend/cater/get_caters.php");
        const data = await response.json();

        if (data.success) {
          setCaterCount((data.caters || []).length);
        }
      } catch (error) {
        console.error("Failed to fetch cater count:", error);
      }
    };

    fetchCaters();
  }, []);

  return (
    <AdminLayout user={user}>
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl md:text-3xl font-bold text-slate-900">
            Welcome back, {user.name || "User"}
          </h1>
          <p className="text-sm text-slate-500 mt-1">
            Member ID: {user.member_id || "-"} | Email: {user.email || "-"}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-5">
          <StatCard title="Total Orders" value="128" change="+12.5% this month" />
          <StatCard title="Active Users" value="1,248" change="+8.2% this month" />
          <StatCard title="Revenue" value="₹2,45,000" change="+10.4% this month" />
          <StatCard
            title="Caters"
            value={caterCount}
            change={`${caterCount} cater${caterCount !== 1 ? "s" : ""} available`}
          />
        </div>

        <div className="grid grid-cols-1 xl:grid-cols-3 gap-6">
          <div className="xl:col-span-2">
            <RecentOrders />
          </div>

          <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-5">
            <h2 className="text-lg font-semibold text-slate-900 mb-4">
              Account Summary
            </h2>

            <div className="space-y-4">
              <div className="rounded-xl border border-slate-200 bg-slate-50 p-4">
                <p className="text-sm text-slate-500">Full Name</p>
                <p className="text-base font-semibold text-slate-900 mt-1">{user.name || "-"}</p>
              </div>

              <div className="rounded-xl border border-slate-200 bg-slate-50 p-4">
                <p className="text-sm text-slate-500">Member ID</p>
                <p className="text-base font-semibold text-slate-900 mt-1">{user.member_id || "-"}</p>
              </div>

              <div className="rounded-xl border border-slate-200 bg-slate-50 p-4">
                <p className="text-sm text-slate-500">Email Address</p>
                <p className="text-base font-semibold text-slate-900 mt-1 break-all">{user.email || "-"}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
}

export default Dashboard;